import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactCardSection, useProviderSection } from "@/contexts/contact";
import { Box } from "@gemini/core";
import { useI18n } from "@/contexts/i18n";
import { PublisherTypeEnum } from "@/types";
export const ContactCardTitle = ({ rootTestId }) => {
    var _a;
    const contactCardSection = useContactCardSection();
    const publisherType = (_a = useProviderSection()) === null || _a === void 0 ? void 0 : _a.publisherType;
    const { t } = useI18n();
    return (_jsxs(Box, { textAlign: "center", marginTop: {
            "breakpoint.base": "spacing.16",
            "breakpoint.xxxl": "spacing.24",
        }, marginBottom: {
            "breakpoint.base": "spacing.12",
            "breakpoint.xxxl": "spacing.16",
        }, children: [_jsx(Box, { testId: `${rootTestId}.Subtitle`, color: "color.content.light.default", typography: {
                    "breakpoint.base": "typography.body.16.regular",
                }, children: publisherType && PublisherTypeEnum[publisherType]
                    ? t(PublisherTypeEnum[publisherType])
                    : contactCardSection === null || contactCardSection === void 0 ? void 0 : contactCardSection.subtitle }), _jsx(Box, { testId: `${rootTestId}.Title`, typography: {
                    "breakpoint.base": "typography.body.16.bold",
                    "breakpoint.xxxl": "typography.headline.20.bold",
                }, children: contactCardSection === null || contactCardSection === void 0 ? void 0 : contactCardSection.title })] }));
};
